import './NewsArticleMetadata.scss';
import { Heading } from '@lmig/lmds-react-typography';
import { useContext, useEffect, useState } from 'react';
import { useUserData } from 'Foundation/User/UserContext';
import { GetSiteStatesAbbr } from 'Foundation/Common/StateHelper';
import { INewsArticleContext, NewsArticleContext } from './NewsArticleContext';

export function NewsArticleMetadata() {
  const [isNational, setIsNational] = useState<boolean>(false);
  const { userData } = useUserData();
  const articleContext = useContext<INewsArticleContext>(NewsArticleContext);

  useEffect(() => {
    if (articleContext.article?.States?.length) {
      if (userData?.channel) {
        const siteStates = GetSiteStatesAbbr(userData.channel);
        const unselectedStates = siteStates.filter((value) => !articleContext.article?.States?.includes(value));
        setIsNational(unselectedStates.length === 0);
      }
    }
  }, [articleContext.article?.States, userData?.channel]);

  return (
    <>
      {articleContext?.article && (
        <div className="news-metadata-container">
          <div className="headline-container">
            <Heading type="h3" className="headline">
              {articleContext.article.Headline}
            </Heading>
          </div>
          <div className="news-article-metadata">
            <div>State(s): {isNational ? 'Countrywide' : articleContext.article.States?.sort().join(', ')}</div>
            {articleContext.article.Products && articleContext.article.Products.length > 0 && (
              <div>Product(s): {articleContext.article.Products?.sort().join(', ')}</div>
            )}
            {articleContext.article.NewBusinessEffectiveDate && (
              <div>New business effective date: {articleContext.article.NewBusinessEffectiveDate}</div>
            )}
            {articleContext.article.RenewalEffectiveDate && (
              <div>Renewal effective date: {articleContext.article.RenewalEffectiveDate}</div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default NewsArticleMetadata;
